module.exports = __webpack_public_path__ + "fonts/TitilliumWeb-Regular.57e937e4.ttf";